<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" :class="items.class">
        <div
          :class="['user-guide-mask', 'user-guide-mask-' + items.type]"
          v-if="items.needMask"
        >
          <template v-if="items.type === 'default'">
            <div
              class="user-guide-top"
              :style="{
                height: items.highlightArea.top + isMsgTop + 'px',
              }"
            ></div>
            <div
              class="user-guide-left"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                width: items.highlightArea.left + 'px',
                height: items.highlightArea.height + 'px',
              }"
            ></div>
            <div
              class="user-guide-right"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                left: items.highlightArea.left + items.highlightArea.width + 'px',
                height: items.highlightArea.height + 'px',
              }"
            ></div>
            <div
              class="user-guide-bottom"
              :style="{
                top:
                  items.highlightArea.top +
                  isMsgTop +
                  items.highlightArea.height +
                  'px',
              }"
            ></div>
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: items.guideAreaTop ? (clientHeight - items.modalArea.height) / 2 + items.guideAreaTop + 'px' : '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth) / 2 - (items.guideAreaLeft || 0) +  'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left: items.guideArea.left + 'px',
          }"
        >
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content">{{ items.content }}</div>
            <i
              class="el-icon-close size16 gj-ml8 gj-pointer"
              @click="setUserGuideState"
              style="color: rgba(255, 255, 255, 0.4)"
            ></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/{{data.length}}</div>
            <div v-if="items.btnList.length" class="btnList">
              <div v-if="items.btnList.includes('video')" class="gj-pointer">
                <gj-link style="color:#fff;" type="text" :href="getVideoUrl(taskItem.videoUrlCode)" target="_blank">参考教程 </gj-link><i class="el-icon-arrow-right"></i>
              </div>
              <div v-if="items.btnList.includes('know')" @click="nextStep()" class="gj-pointer knowBtn">我知道了</div>
              <div v-if="items.btnList.includes('complete')" @click="nextTask" class="gj-pointer completeBtn">完成任务</div>
            </div>
          </div>
          <div v-if="items.guideDirection === 'left'" class="user-guide-point" :style="{ width: items.guideWidth + 'px', left: `-${items.guideWidth}px` }">
            <div class="user-guider-line"></div>
          </div>
          <div v-if="items.guideDirection === 'top'" class="user-guide-point" :style="{ width: items.guideWidth + 'px', transform: 'rotate(90deg)', top: `-${items.guideWidth/2}px`, left: '50%', marginLeft: `-${items.guideWidth/2}px` }">
            <div class="user-guider-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import { mapGetters } from "vuex";
import { userGuideMixin } from "@/minxins";
const clientWidth = document.body.clientWidth
const clientHeight = document.body.clientHeight

export default {
  name: "new-user-management-guidelines",
  mixins: [userGuideMixin],
  data() {
    return {
      bootSteps: 0,
      data: null,
      isMsgTop: 0,
      clientWidth,
      clientHeight,
      taskItem: null
    };
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: "isMsgsGlobal",
      userGuideState: "userGuideState",
    }),
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate: true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    },
  },
  created() {
    this.initData()
    this.bootSteps = 1;
    this.taskItem = this.userGuideTaskItem;
  },
  methods: {
    initData(){
      const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical'
      const subtractHeight =  isNavHorizontal ? 0 : 40;
      const addWidth =  isNavHorizontal ? 0 : 60;
      this.subtractHeight = subtractHeight;
      this.addWidth = addWidth;
      this.data = [
        {
          id: 1,
          class: "user-guide-one",
          type: "default",
          needMask: true,
          highlightArea: {
            width: 64,
            height: 32,
            top: 148 - subtractHeight,
            left: 294 + addWidth,
          },
          guideArea: {
            top: 130 - subtractHeight,
            left: 405 + addWidth,
          },
          guideDirection: 'left',
          guideWidth: 60,
          content: "点击【添加用户】，新增系统用户",
          btnList: [],
        },
         {
          id: 2,
          class: "user-guide-four",
          type: "modal",
          needMask: false,
          modalArea: {
            width: 850,
            height: 689
          },
          guideDirection: 'left',
          guideAreaTop: 655 - subtractHeight / 2,
          guideWidth: 100 - addWidth,
          content: "填写用户账号的基础资料，并为授权其可以查看的数据和可操作的功能~",
          btnList: ['video'],
        },
        {
          id: 3,
          class: "user-guide-five",
          type: "default",
          needMask: true,
          highlightArea: {
            width: clientWidth - 278 - 30 - addWidth,
            height: 199,
            top: 195 - subtractHeight,
            left: 290 + addWidth,
          },
          guideArea: {
            top: 480 - subtractHeight,
            left: 900 + addWidth,
          },
          guideDirection: 'top',
          guideWidth: 100,
          content:
            "用户添加完成~您的小伙伴可以登录系统啦~",
          btnList: ['complete'],
        },
      ]
    },
    prevStep() {
      this.bootSteps--;
    },
    nextStep(step) {
      if(step) {
        this.bootSteps = step
      } else {
        this.bootSteps++;
      }
      if(this.bootSteps == 3) {
        this.$emit('closeModal');
      }
    },
    async nextTask() {
      const taskItem = this.taskItem;
      const { finishTaskList } = await this.getNextTask(taskItem?.taskTypeCode, taskItem?.taskChildCode);
      if(finishTaskList && taskItem.taskStatus != 'COMPLETED') {
        this.completeTask();
      } else if(finishTaskList) {
        this.setUserGuideState()
      }
    },

    completeTask() {
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      this.$gjCreate(appUserGuideSucc,{
        global: true,
        props: {
          id: this.taskItem?.taskTypeCode
        }
      })
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  },
};
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top,
  .user-guide-left,
  .user-guide-right,
  .user-guide-bottom {
    position: fixed;
    top: 0px;
    left: -16px;
    right: -16px;
    bottom: -16px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: fixed;
  top: 75px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 2100;
  background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994fc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: fixed;
  z-index: 2200;
  .user-guide-point {
    width: 40px;
    position: absolute;
    left: -40px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994fc;
      &::before {
        // 小圆点在这里
        content: "";
        border: 1px solid #4994fc;
        background-color: #4994fc;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
      }
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
</style>